module.exports = __webpack_public_path__ + "media/public/images/icon-tooltip-hover-945fd92de61db91ebc4824112aa38c63.svg";